import { RSLinkClickedLocation, useRudderstackClient, } from '@redbubble/next-provider/rudderstack';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';
import { TopicNav } from './TopicNav';
import { createTopicNavRouting } from './topicNavRouting';
import { useTopicNavConfig } from './useTopicNavConfig';
import { useTopicNavExperiment } from './useTopicNavExperiment';
var expandSideMenuTray = function () {
    var _a;
    (_a = document
        .querySelector('[data-testid="ds-header-hamburger-action"]')) === null || _a === void 0 ? void 0 : _a.click();
};
/**
 * Gathers the ambient state the topic nav depends on (experiment enrolment,
 * current location, analytics) and hands TopicNav ready-to-render items.
 */
export var TopicNavWithConfig = function () {
    var location = useRouter().asPath;
    var behaviour = useTopicNavExperiment();
    var config = useTopicNavConfig();
    var RudderstackClient = useRudderstackClient().RudderstackClient;
    var routing = useMemo(function () { return createTopicNavRouting(config, behaviour); }, [config, behaviour]);
    var navState = routing.deriveState(location);
    var toItem = function (_a) {
        var Icon = _a.Icon, category = _a.category, label = _a.label;
        var href = routing.buildHref(category, navState);
        if (href === undefined)
            return [];
        return [
            {
                href: href,
                label: label,
                Icon: Icon,
                active: routing.isActive(category, navState),
                onClick: function () {
                    return RudderstackClient === null || RudderstackClient === void 0 ? void 0 : RudderstackClient.linkClicked({
                        link_label: label,
                        location: RSLinkClickedLocation.NavSub,
                    });
                },
            },
        ];
    };
    return (React.createElement(TopicNav, { topics: config.topics.flatMap(toItem), products: config.products.flatMap(toItem), onProductsHeadingClick: expandSideMenuTray }));
};
